export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8113.570cba31.jpg";